<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-20">
            My Success Roadmap
        </div>
        <div class="content card round-medium" :style="loadBg">
            <div class="top-bar" :style="loadBar"></div>
            <div class="content-title padding-5 margin-top-20">
                <div class="roadmap-back-wrapper ipad-display">
                    <router-link :to="'success-roadmap'" class="margin-top-0">
                        <img :src="'images/mpower-new/my_success_roadmap/back.png'" class="responsive-image roadmap-back-img"/>
                    </router-link>
                </div>
                <div class="roadmap-back-wrapper mobile-display">
                    <router-link :to="'success-roadmap'" class="margin-top-0 ">
                        <img :src="'images/mpower-new/my_success_roadmap/back.png'" class="responsive-image roadmap-back-img"/>
                    </router-link>
                </div>
                <div class="roadmap-title-wrapper">
                    Your development Journey<br>
                    with Training support
                </div>
                <div class="clear"></div>
            </div>

             <!-- mobile -->
             <div class="mobile-display">
                <div class="responsive-iframe">
                    <video width="90%" controls onloadedmetadata="this.muted = true" playsinline autoplay muted loop>
                        <source :src="'images/mpower-new/my_success_roadmap/development/video/delevopment.mp4'" type="video/mp4">
                    </video>
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/01.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/02.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/03.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/04.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/05.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/06.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/07.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/08.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/09.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/mobile/10.png'" class="responsive-image">
                </div>
                <div  class="margin-bottom-30">
                    <a target="_blank" href="images/mpower-new/my_success_roadmap/development/pdf/Generali Training Road Map 2024.pdf" class="d-inline-block">
                        <img :src="'images/mpower-new/my_success_roadmap/development/mobile/11.png'" class="responsive-image" style="margin: 0 auto" width="70%">
                    </a>
                </div>
                <div class="clear"></div>
            </div>

            <!-- ipad -->
            <div class="ipad-display">
                <div class="responsive-iframe">
                    <video width="90%" controls onloadedmetadata="this.muted = true" playsinline autoplay muted loop>
                        <source :src="'images/mpower-new/my_success_roadmap/development/video/delevopment.mp4'" type="video/mp4">
                    </video>
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/01.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/02.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/03.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/04.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/05.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/06.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/07.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/08.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/separator.png'" class="responsive-image"/>
                </div>

                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/09.png'" class="responsive-image">
                </div>
                <div>
                    <img :src="'images/mpower-new/my_success_roadmap/development/iPad/10.png'" class="responsive-image">
                </div>
                <div  class="margin-bottom-60">
                    <a target="_blank" href="images/mpower-new/my_success_roadmap/development/pdf/Generali Training Road Map 2024.pdf" class="d-inline-block">
                        <img :src="'images/mpower-new/my_success_roadmap/development/iPad/11.png'" class="responsive-image" style="margin: 0 auto">
                    </a>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <RoadmapNav />
    </div>
</template>
<style scoped>
.mobile-display .mandatory{
    text-align: left;
    padding-left: 10px;
    color:#6b867f;
}
.ipad-display .mandatory{
    text-align: left;
    padding-left: 10px;
    color:#6b867f;
}
.mobile-display .notes{
    text-align: left;
    font-size: 11px;
    font-style: italic;
    line-height: 1.5;
    padding-left: 10px;
    color:#FF4500;
}
.ipad-display .notes{
    text-align: left;
    font-size: 11px;
    font-style: italic;
    line-height: 1.5;
    padding-left: 10px;
    color:#FF4500;
}
</style>
<script>
import RoadmapNav from '@/components/RoadmapNav.vue'
export default {
    name: 'Agent_journey',
    computed: {
        loadBg(){
            return {
                'backgroundImage': 'url(\'images/mpower/roadmap/blank_bg.png\')',
                'background-size': 'cover',
                'background-position': 'center',
                'background-repeat': 'no-repeat'
            }
        },
        loadBar() {
            return {
                'background': '#AFC8B4'
            }
        }
    },
    components: {
        RoadmapNav
    },
    mounted(){
        window.scrollTo(0,0);
    }
}
</script>
